export default __webpack_public_path__ + "static/gb-nir-47c192a3f646281272c3b91088d7e5e6.svg";